import React, { useEffect } from 'react'
import { Body, Button, Spacer } from '@spritz-finance/ui'
import { Row } from '../../components/Layout/Row'
import { CenteredPageInner, PageContainer } from '../../components/Layout/PageContainer'
import { Card } from '../../components/Layout/Card'
import { Column } from '../../components/Layout/Column'
import RewardsCoins from '../../assets/img/growsurf-rewards-coins.svg'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { useCurrentUserQuery } from '../../context/useCurrentUser'
import { formatCurrency } from '../../utils/format'

const RewardsCoinsImage = styled.img.attrs({
    src: RewardsCoins,
})`
    margin-right: 16px;
`

const RewardsCard = styled(Card)`
    padding: 32px;
`

export const RewardsSubPage: React.VFC = () => {
    const { growsurf, refetch } = useCurrentUserQuery()
    const navigate = useNavigate()

    useEffect(() => {
        if (!growsurf?.participant) {
            refetch()
        }
    }, [growsurf])

    const isPendingReferred =
        growsurf?.participant?.referralSource === 'PARTICIPANT' &&
        growsurf?.participant?.referralStatus === 'CREDIT_PENDING'

    const hasBalance = !!growsurf?.rewardsBalance

    return (
        <CenteredPageInner $width={600}>
            <PageContainer>
                {isPendingReferred && (
                    <>
                        <RewardsCard>
                            <Row>
                                <RewardsCoinsImage />

                                <Column>
                                    <Body.Med size={18}>
                                        You’ve been invited by a friend! Make a bill payment of $50
                                        or more and you’ll receive a $20 reward once your payment
                                        clears.
                                    </Body.Med>
                                    <Spacer height={24} />
                                    <Row align="center" style={{ width: '100%' }}>
                                        <Button.CTA onClick={() => navigate('/bills/main')}>
                                            Pay a bill
                                        </Button.CTA>
                                    </Row>
                                </Column>
                            </Row>
                        </RewardsCard>
                        <Spacer height={32} />
                    </>
                )}

                <Card>
                    <Row align="center">
                        <Body.SmBold size={48} color={hasBalance ? '#0DC3CA' : 'inherit'}>
                            {formatCurrency(growsurf.rewardsBalance)}
                        </Body.SmBold>
                    </Row>
                    <Spacer height={4} />
                    <Row align="center">
                        <Body.SmBold size={14}>
                            Rewards balance available to pay your bills!
                        </Body.SmBold>
                    </Row>
                </Card>
                <Spacer height={24} />
            </PageContainer>
        </CenteredPageInner>
    )
}
